<template>
  <div class="english-container">
    <h2>Productoverzicht</h2>
    <p  style="text-align: left;" >Wij delen uw enthousiasme over de draadloze tag voor Android-track- ers. Deze zijn ontworpen om naadloos te integreren met de Vind mijn apparaat-app van Google en helpen u uw items te volgen met behulp van miljarden Android-apparaten wereldwijd.
</p>
  
    <p  style="text-align: left;" >De draadloze tag is een slim trackerapparaat dat gebruikmaakt van de Google Find My Device-service en gekoppeld is aan de app "Google Find My Device" op Android-apparaten. Zo kunt u uw persoonlijke bezittingen snel en veilig terugvinden op Google Maps. Alle locatiegegevens blijven privé en zelfs Google heeft er geen toegang toe.

</p>

<h3> 1. Meld u aan bij de app Zoek mijn apparaat</h3>
  <ol>
    <li>Ga naar Google Play en zoek naar'Find Hub.</li>
    <li>Installeer de app of klik op 'Bijwerken'.</li>
    <li> Klik op 'Openen' of klik op het apppictogram 'Vind mijn apparaat' op de startpagina van uw telefoon.</li>
    <li><p>Meld u aan bij de pagina Vind mijn apparaat met uw Google-account.</p>
      <p>● Mogelijk wilt u het selectievakje 'Niet meer vragen' aanvinken.</p>
      <p>● Als u meer dan één account hebt, wordt uw item gekoppeld aan het primaire account op uw telefoon.</p>
    </li>
    <li> Mogelijk wordt u gevraagd om bepaalde rechten toe te staan. Bekijk de voorwaarden en ga verder.
</li>
  </ol>

  <h3>2. Inschakelen</h3>
  <p style="text-align: left;">
    <strong> Inschakelen: </strong> Houd de ronde stip op de aan/uit-knop van het apparaat 3 seconden ingedrukt. Wanneer u een luide beltoon hoort, betekent dit dat het apparaat is ingeschakeld. (Zie foto.)
  </p>

   <img src="../assets/gid_1_nl.png" alt="Wireless Tag Logo" class="image_1" />

<h3>3. Maak verbinding met de app Zoek mijn apparaat</h3>
  
      <p style="text-align: left;">
        3.1 Zorg ervoor dat Bluetooth op uw telefoon is ingeschakeld en dat u verbinding hebt met internet.
      </p>
 <p style="text-align: left;">
  3.2 Houd je tag dicht bij je telefoon en wacht tot de pop-up Draadloze tag weergeeft. Klik op 'Verbinden' in het onderste deel van de pop-up. Lees en accepteer de instructies om de koppeling te voltooien.
</p>

<h3>4. Productintroductie</h3>
<h4>4.1 In de buurt vinden</h4>
<p style="text-align: left;">
  4.1.1 Soms bent u dichter bij uw verloren voorwerp dan u denkt. Als u weet dat het ergens in huis ligt, geeft 'Vind mijn apparaat' de signaalsterkte aan, zodat u de locatie ervan kunt bepalen.
</p>
<p style="text-align: left;">
4.1.2 Als uw apparaat zich binnen het draadloze bereik bevindt, selecteert u uw apparaat in de app 'Google Vind mijn apparaat' en tikt u op 'Geluid afspelen' om het apparaat te lokaliseren. Zodra het apparaat is gevonden, tikt u op 'Geluid stoppen' om het apparaat uit te zetten.</p>
<p style="text-align: left;">
4.1.3 Google Assistent op je Google Home of Pixel Watch staat voor je klaar. Probeer prompts zoals "Hey Google, vind mijn portemonnee" of "Hey Google, vind mijn sleutels" om je spullen snel terug te vinden.
</p>
<h4>4.2 Een community voor het vinden</h4>
  <p style="text-align: left;">
Voor de momenten waarop je echt ver van een item verwijderd bent, staat het Find My Device-netwerk voor je klaar. Android-apparaten over de hele wereld – zoals tablets, telefoons en laptops – werken samen om je te helpen die tablet te vinden die je twee tussenstops geleden in het vliegtuig hebt laten liggen.
</p>
<h4>4.3 Verloren-modus inschakelen</h4>
 <p style="text-align: left;">
Wanneer uw item verloren is, selecteert u het apparaat in de app 'Google Vind mijn apparaat' en tikt u op 'Markeren als verloren'. U ontvangt een melding wanneer de locatie beschikbaar is. U kunt uw contactgegevens achterlaten zodat de vinder van uw item contact met u kan opnemen.
  </p>

  <h4>4.4 Locatie delen</h4>

   <p style="text-align: left;">
      Selecteer het apparaat in de app 'Google Vind mijn apparaat' en tik vervolgens op 'Delen'. De locatie wordt dan zichtbaar in de lijst in de app 'Vind mijn apparaat'. Beide accounts zien de locatie-updates en kunnen het apparaat lokaal bellen. </p>

  <h4>4.5 Waarschuwingen voor onbekende trackers</h4>
   <p style="text-align: left;">
Uw veiligheid staat voorop. Zoek mijn apparaat is ontworpen om ongewenste tracking te voorkomen. Als uw Android-telefoon een onbekend apparaat met u meebeweegt, ontvangt u een melding. Bekijk het onbekende apparaat op een kaart, bel het om het met geluid te vinden of krijg verdere hulp.
  </p>

  <h4>4.6 Privacy</h4>
   <p style="text-align: left;">
Uw locatiegegevens zijn end-to-end versleuteld, wat betekent dat
Google deze nooit kan inzien of openen. Alleen u kunt zien waar uw 3V items zijn geweest en zich momenteel bevinden. Met de app Vind
mijn apparaat gebruikt of deelt Google uw gegevens niet. De
informatie die u over uzelf en uw apparaten deelt, blijft vertrouwelijk.  </p>
  
 <h3>5. Vervanging van batterij en koord</h3>
  <p style="text-align: left;">
      5.1 Maak de behuizing open met een gereedschap voor het openen van de behuizing.
  </p>

   <p style="text-align: left;">
      5.2 Draai het gereedschap voor het openen van de behuizing 90 graden om de behuizing te openen.
  </p>

   <p style="text-align: left;">
5.3 Gebruik uw vingernagels bij de kleine opening aan de zijkant van uw Item Locater om de behuizing voorzichtig te openen.  </p>

   <p style="text-align: left;">
      5.4 Vervang de batterij door een nieuwe CR2032-batterij van 3 V. (Pluspool met de tekst naar boven).
  </p>

     <img src="../assets/open_tag_nl.png" alt="Wireless Tag Logo" class="image_1" />

  <h3>6. Knopfunctie</h3>
  <ol>
    <li style="text-align: left;">
      Inschakelen (Zoek mijn-functie is ingeschakeld).
      <p>
        Druk 3 seconden op de functieknop om het apparaat in te schakelen. Er zou een pieptoon moeten klinken om aan te geven dat het apparaat is ingeschakeld.        </p>
        <p> Als het product niet is gekoppeld aan uw Google-account, wordt het binnen 10 minuten automatisch gesloten. U moet de Zoek mijn-functie opnieuw activeren om door te gaan met koppelen.</p>
      </li>
    <li style="text-align: left;">Uitschakelen (Zoek mijn-functie is uitgeschakeld).
      <p>
        Houd de functieknop drie seconden ingedrukt en laat deze <strong>vervolgens los...</strong> U hoort twee pieptonen die aangeven dat het apparaat is uitgeschakeld.
      </p>
    </li>
    <strong  style="text-align: left;">
      <p>Opmerking:</p>
      <p>1. Als u de knop korter dan 3 seconden of langer dan 5 seconden ingedrukt houdt, wordt het apparaat niet uitgeschakeld.</p>
      <p>2. Een uitschakeltimer is bedoeld om onbedoeld uitschakelen te voorkomen en ervoor te zorgen dat het apparaat effectief kan blijven zoeken.</p>
    </strong>

    <li style="text-align: left;">Fabrieksinstellingen herstellen</li>
    <p style="text-align: left;"> 
      Druk twee keer op de functieknop. U hoort één pieptoon. Druk vervolgens vier keer snel achter elkaar op de functieknop en houd deze een vijfde keer ingedrukt totdat u een pieptoon hoort. Het apparaat is nu gereset.   
   </p>
  </ol>

  <h3>  FAQ  </h3>
  <h4>Ik kan mijn apparaat niet verbinden met de app 'Vind mijn apparaat' van Google Het volgende wordt aanbevolen:</h4>
<ol>
  <li style="text-align: left;">RStart de Bluetooth- en mobiele netwerkverbinding van je telefoon opnieuw op. Start de Bluetooth- en mobiele netwerkverbinding van je telefoon opnieuw op, sluit het apparaat af en start het opnieuw op en wacht tot de pop-up 'Wireless tag' toont.
</li>
  <li style="text-align: left;">Reset uw apparaat.
Reset je apparaat, sluit het af en start het opnieuw op. Wacht vervolgens tot de pop-up 'Wireless tag' toont.
</li>
  <li style="text-align: left;">Start uw telefoon opnieuw op en probeer het opnieuw.
Start uw telefoon opnieuw op, sluit het apparaat af en start het opnieuw op en wacht tot de pop-up 'Wireless tag' weergeeft.
</li>
<li style="text-align: left;"> Werk de software van uw telefoon bij.
  <p>
    Stap 1. Ga naar de telefooninstellingen en zoek naar "Systeem".</p>
<p>Stap 2. Zoek naar Software-updates en open "Systeemupdate" en controleer vervolgens op updates.</p>
<p>Stap 3. Werk het systeem van uw telefoon bij naar een nieuw systeem </p>
</li>
<li style="text-align: left;">Zoek de Google-service van je telefoon om het apparaat te verbinden.
  <p>Stap 1. Ga naar de telefooninstellingen en zoek 'Google-services en -voorkeuren'.</p>
<p>Stap 2. Ga naar 'Google-services en -voorkeuren' en zoek 'Alle services'.</p>
<p>Stap 3. Ga naar 'Alle services' en zoek 'Verbonden apparaten en delen'.</p>
<p>Stap 4. Ga naar 'Apparaten' en zoek naar 'Beschikbare apparaten in de buurt'. Als u Wireless tag' ziet, klikt u op de Wireless tag' en wacht u tot de pop-up Wireless tag' toont.</p>
<p>Stap 5. Als u de "Wireless tag" niet ziet, moet u het apparaat uitschakelen en opnieuw opstarten totdat u de "Wireless tag" ziet. U kunt ook uw apparaat resetten, het apparaat uitschakelen en opnieuw opstarten totdat u de "Wireless tag" ziet. Klik vervolgens op de "Wireless tag" en wacht tot de pop-up "Wireless tag" weergeeft en tik erop om verbinding te maken.</p>
</li>
</ol>
<p style="text-align: left; color:#333 "  >Zodra het apparaat aan een Google-account is gekoppeld, is het niet langer toegankelijk voor andere gebruikers.</p>
<p style="text-align: left; color:#333 "  >Wanneer uw item zich in de buurt bevindt, kunt u het in de app verwijderen. Er zou een beltoon moeten klinken om aan te geven dat het succesvol is verwijderd. Vervolgens kan het door anderen worden gebruikt.</p>
<p style="text-align: left; color:#333 "  >Wanneer uw item zich buiten het bereik van de verbinding van uw telefoon bevindt en uw Locator uit de Zoek mijn-app wordt verwijderd, kan het apparaat niet meer door anderen worden gebruikt. U moet uw Locator resetten om het door anderen te kunnen gebruiken.</p>

<h3>WAARSCHUWING</h3>
<ol>
  <li>Verwijder en recycle de gebruikte batterijen onmiddellijk of gooi ze weg volgens de plaatselijke voorschriften. Houd de batterijen buiten bereik van kinderen. Gooi batterijen NIET weg bij het huisvuil en verbrand ze niet.</li>
  <li>Zelfs gebruikte batterijen kunnen ernstig letsel of de dood veroorzaken.</li>
  <li>Neem contact op met een lokaal antigifcentrum voor informatie over de behandeling. </li>
  <li>Niet-oplaadbare batterijen mogen niet worden opgeladen.</li>
  <li>Niet geforceerd ontladen, opladen, demonteren, verhitten boven 50 °C/122 °F of verbranden.</li>
  <li>Dit kan leiden tot letsel door ontluchting, lekkage of een explosie met chemische brandwonden tot gevolg. </li>
  <li>De nominale batterijspanning: DC 3 V.</li>
  <li> Het compatibele batterijtype is CR2032.</li>
  <li>Zorg ervoor dat de batterijen correct zijn geplaatst met de polariteit (+ en -). 9. Gebruik geen oude en nieuwe batterijen, verschillende merken of typen batterijen, zoals alkaline-, koolstofzink- of oplaadbare batterijen, door elkaar.</li>
  <li>Verwijder en recycleer batterijen onmiddellijk of gooi ze weg uit</li>
</ol>
<h5>
  <p>Batterijtype: CR2032. Batterijspanning: 3V.</p>
<p>Bewaar in de originele verpakking tot gebruik;</p>
<p>Gooi gebruikte batterijen onmiddellijk weg en houd ze buiten bereik van kinderen.
  Gooi batterijen NIET bij het huisvuil.
</p>
</h5>

<img src="../assets/image_battery.png" class="image_1">

</div>

</template>

<script>
export default {
  name: 'NetherlandLuage',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>